export const PromiseState = {
    isPending: async <T>(promise: Promise<T>) => {
        const t = {};
        return Promise.race([promise, t]).then(
            (v) => (v === t ? true : false),
            () => false
        );
    },
};
